import { ErrorHandler, inject, Injectable } from '@angular/core';
import { DialogComponent, DialogService } from '@bioreferencehealth/ui-kit';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { WINDOW } from 'src/app/tokens/window.token';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class AppErrorHandler implements ErrorHandler {
  protected window = inject(WINDOW);
  protected dialogService = inject(DialogService);
  handleError(error: any): void {
    if (error && error.message && error.message.includes('Loading chunk')) {
      this.showDialogAboutReloadByNewVersion();
    } else {
      console.error(error);
    }
  }
  private showDialogAboutReloadByNewVersion(): void {
    this.dialogService
      .open(DialogComponent, {
        data: {
          title: 'New Version Detected',
          content: `New version of the application is detected. The page should be reloaded.`,
          closeButtonText: 'Reload'
        }
      })
      .afterClosed()
      .pipe(untilDestroyed(this))
      .subscribe(() => this.window.location.reload());
  }
}
